// Vue
import {Component, Prop, Vue} from 'vue-property-decorator'
// Template
import template from './template.vue'
import {Communication} from "../../communication/Communication";
import {Button} from "../../button/Button";
import {Form} from "../../form/Form";
import {InputGroup} from "../../input_group/InputGroup";
import {Select} from "../../select/Select";
import {SelectOption} from "../../select/option/SelectOption";
import {Textarea} from "../../textarea/Textarea";
import {FileInput} from "../../file_input/FileInput";

@Component({
    name: 'CommunicationModuleMessageInput',
    mixins: [
        template,
    ],
    components: {
        Communication,
        /*Button,
        Form,
        InputGroup,
        Select,
        SelectOption,
        Textarea,
        FileInput*/
    }
})
export class CommunicationModuleMessageInput extends Vue {

    @Prop()
    private recipientList!: object[]

    @Prop({default: true})
    private subjectOptional!: boolean

    @Prop({default: 'Empfänger Liste'})
    private labelRecipientListField!: string

    @Prop({default: 'Nachricht'})
    private labelMessageField!: string

    @Prop({default: 'Betreff'})
    private labelSubjectField!: string

    @Prop({default: 'Anhänge'})
    private labelAttachmentField!: string

    @Prop({default: 'entfernen'})
    private removeAttachmentLinkText!: string

    @Prop({default: 'Absenden'})
    private submitButtonText!: string

    @Prop({default: 'Abbrechen'})
    private abortButtonText!: string

    @Prop({default: 'Neue Nachrichten laden'})
    private labelRefreshMessages!: string

    @Prop({default: true})
    private showRefreshButton!: boolean

    @Prop({default: null})
    private parentId!: string | null

    @Prop({default: ['image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint']})
    private supportedFileTypes!: string[]

    @Prop({default: 4194304})
    private maxFileSize!: number

    @Prop()
    private errorTooLarge!: string

    @Prop()
    private errorUnsupportedType!: string

    private message: string = ''
    private recipient: string = ''
    private uuid: string = ''
    private subject: string = ''
    private attachments: object[] = []

    get recipientListId() {
        return 'recipient-list-' + this.uuid;
    }

    get isValid():boolean {
        const has_recipients = this.recipient ||  this.recipientList.length === 0
        if(!has_recipients || !this.message) return false
        return this.subjectOptional ? true : !!this.subject
    }

    get accept() {
        return this.supportedFileTypes.join(', ');
    }

    created() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        this.uuid = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    refresh(event) {
        event.preventDefault();
        this.$emit('refresh');
    }

    sendMessage(event) {
        event.preventDefault();
        if (this.isValid) {
            this.$emit('sendMessage', this.parentId, this.subject, this.message, this.recipient, this.attachments);
            this.message = "";
            this.subject = "";
            this.attachments = [];
        }
    }

    abortMessage(event) {
        event.preventDefault();
        this.message = "";
        this.subject = "";
        this.attachments = [];
        this.$emit('abortMessage');
    }
}